import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Switch } from '@andritzot/metris-web-ui/inputs/switch';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';

interface AgreePrivacyFieldProps {
  control: Control<FormProps>;
}

export function AgreePrivacyField({ control }: Readonly<AgreePrivacyFieldProps>) {
  return (
    <Controller
      name="agreePrivacy"
      control={control}
      rules={{ required: 'required' }}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Box>
            <Switch checked={value} onChange={(e) => onChange(e.target.checked)} />
          </Box>
          <Typography variant="body2" sx={{ color: error ? 'error.main' : 'text.primary' }}>
            I have read and agree to the{' '}
            <Box component="a" href="https://www.andritz.com/privacy" target="_blank" rel="noreferrer">
              ANDRITZ data privacy declaration
            </Box>
            {'. '}I can revoke this consent at any time.
          </Typography>
        </Box>
      )}
    />
  );
}
